import { LoadingState } from '@lcs/shared/api';
import { on } from '@ngrx/store';
import { createDeviceSuccess } from 'src/app/pages/add-devices/state/add-device.actions';
import { addHardphoneSuccess } from 'src/app/pages/add-phone-to-device/state/add-hardphone.actions';
import { saveDeviceDetailSuccess } from 'src/app/pages/device-details/state/device-detail.actions';
import { DeviceOption } from 'src/app/pages/phones/models/device-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { twoFieldOptionFilter } from '../../select/shared/filter-device-option';
import { deviceOptionActions } from './device-option.actions';

export const deviceOptionFeatureKey = 'deviceOptions';

export type DeviceOptionState = EagerSelectState<DeviceOption>;

const adapter = createEagerSelectAdapter<DeviceOptionState, DeviceOption>({
   featureKey: deviceOptionFeatureKey,
   selectId: (device: DeviceOption) => {
      return device.deviceId;
   },
});

export const deviceOptionSelectors = adapter.getSelectors(twoFieldOptionFilter);

const initialState = adapter.getInitialState();

export const deviceOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   deviceOptionActions.search,
   deviceOptionActions.searchReset,
   deviceOptionActions.loadFromApi,
   deviceOptionActions.loadFromApiSuccess,
   deviceOptionActions.loadFromApiFailure,
   null,
   on(createDeviceSuccess, saveDeviceDetailSuccess, addHardphoneSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Init,
      };
   })
);
